import React, { useCallback } from "react";
import PropTypes from "prop-types";
import { Tab, Tabs, Divider } from "@mui/material";
import { Card } from "@totalsoft/rocket-ui";
import SwipeableViews from "react-swipeable-views-react-18-fix";
import MessageComponent from "./MessageComponent";
import DisplaySummary from "./DisplaySummary";

const MessagesComponent = ({
  messages,
  onChange,
  getMessages,
  messageTypeList,
  messageActiveTab,
  synchronizationInProgress,
  onRetrySynchronization
}) => {
  const handleTabChange = useCallback(value => () => onChange(value), [onChange]);

  return (
    <Card id={"messages"} disablePadding sx={{ mb: 2, mt: 3 }}>
      <Tabs value={messageActiveTab} variant="fullWidth">
        {messageTypeList.map((messageType, idx) => {
          const disabled = messages.filter(x => x.messageType === messageType).length === 0;

          return (
            <Tab
              id={"messages_" + getMessages(messageType)}
              key={messageType}
              onClick={handleTabChange(idx)}
              icon={<DisplaySummary messageType={messageType} messages={messages} disabled={disabled} />}
              disabled={disabled}
            />
          );
        })}
      </Tabs>
      {messageActiveTab !== false && <Divider sx={{ m: 0 }} />}
      {typeof messageActiveTab === "number" && (
        <SwipeableViews index={messageActiveTab} onChangeIndex={onChange}>
          {messageTypeList.map((messageType, index) => (
            <MessageComponent
              messages={messages}
              key={messageType}
              messageActiveTab={messageActiveTab}
              index={index}
              messageType={messageType}
              synchronizationInProgress={synchronizationInProgress}
              onRetrySynchronization={onRetrySynchronization}
            />
          ))}
        </SwipeableViews>
      )}
    </Card>
  );
};

MessagesComponent.propTypes = {
  messages: PropTypes.array,
  onChange: PropTypes.func,
  messageTypeList: PropTypes.array,
  getMessages: PropTypes.func,
  messageActiveTab: PropTypes.bool,
  synchronizationInProgress: PropTypes.bool,
  onRetrySynchronization: PropTypes.func
};

export default MessagesComponent;
